import { css } from "@emotion/react";
import { theme } from "@/constants/theme";

export const navbarStyles = (scrolled: boolean) =>
  css({
    position: "fixed",
    width: "100%",
    backgroundColor: scrolled ? "white" : "transparent",
    color: scrolled ? theme.palette.text.primary : "white",
    boxShadow: scrolled ? "0 2px 4px rgba(0,0,0,0.1)" : "none",
    transition: "background-color 0.3s ease, color 0.3s ease",
  });

export const toolbarStyles = () =>
  css({
    width: "100%",
    maxWidth: "1440px",
    justifyContent: "space-between",
    margin: "0 auto",
    padding: "0 8px",
    minHeight: "64px",
    display: "flex",
    alignItems: "center",
  });

export const drawerStyles = css({
  height: "100%",
  ".MuiDrawer-paper": {
    width: "260px",
    display: "flex",
    flexDirection: "column",
  },
});

export const logoDrawerStyles = css({
  marginTop: "40px",
});

export const menuButtonStyles = css({
  margin: "0px 16px",
  display: "none",
  [theme.breakpoints.down("md")]: {
    display: "flex",
    alignItems: "center",
  },
});

export const navItemsStyles = css({
  display: "flex",
  gap: "16px",
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
});

export const buttonStyles = css({
  color: "inherit",
  fontSize: "16px",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "transparent",
    textDecoration: "underline",
  },
});

export const logoStyles = (scrolled: boolean) =>
  css({
    fill: scrolled ? theme.palette.primary.main : "white",
    transition: "fill 0.3s ease",
  });

export const drawerFooterStyles = css({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "8px",
  marginBottom: "48px",
  "& > a": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
  },
  p: {
    fontWeight: "600",
    color: theme.palette.secondary.dark,
  },
});
